var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.369 4.35a1 1 0 0 1 1.406 1.406l-.068.077-5.293 5.293H19a1 1 0 1 1 0 2H7.414l5.293 5.293.068.076A1 1 0 0 1 11.37 19.9l-.076-.069-7-7a1 1 0 0 1-.198-.283 1 1 0 0 1-.052-.133l-.013-.05a1 1 0 0 1 .138-.796q.054-.082.125-.152l7-7z"
  })));
};
export default Svg24;